var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.115,
    height: 16.625,
    viewBox: "0 0 15.115 16.625",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_48116",
    "data-name": "Group 48116",
    transform: "translate(-549.936 -404.211)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35934",
    "data-name": "Path 35934",
    d: "M4.513,11H15.1a1.513,1.513,0,0,1,1.513,1.513v5.295A1.513,1.513,0,0,1,15.1,19.32H4.513A1.513,1.513,0,0,1,3,17.808V12.513A1.513,1.513,0,0,1,4.513,11Z",
    transform: "translate(547.686 400.766)",
    fill: "none",
    stroke: "#385576",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35935",
    "data-name": "Path 35935",
    d: "M7,8.808V5.782a3.782,3.782,0,1,1,7.564,0V8.808",
    transform: "translate(546.712 402.961)",
    fill: "none",
    stroke: "#385576",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lock_icon.1d5f25f8.svg";
export { ForwardRef as ReactComponent };